<template>
  <v-footer color="indigo" app>
    <span class="white--text">&copy; 2020 By Csaba vitéz Fehér</span>
  </v-footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped></style>
